import * as THREE from "three";
import {decompressFrames, parseGIF} from 'gifuct-js'
import {ModelLoader} from "./loader";


export class GifLoader {
    loadedFrames;
    frameIndex = 0;
    loop = true;

    c = null;
    ctx = null;
    tempCanvas = null;
    tempCtx = null;
    gifCanvas = null;
    gifCtx = null;
    frameImageData = null;

    material = null;

    _canvas(w,h) {
        this.c = document.createElement('canvas');
        this.ctx = this.c.getContext('2d')
        this.ctx.canvas.width = w
        this.ctx.canvas.height = h


        this.tempCanvas = document.createElement('canvas')
        this.tempCtx = this.tempCanvas.getContext('2d')
        this.gifCanvas = document.createElement('canvas')
        this.gifCtx = this.gifCanvas.getContext('2d')
    }

    render() {
        if (this.frameIndex < 0) {
            console.log('render', this.frameIndex)
            return //Finished loop
        }
        const start = performance.now()
        const frame = this.loadedFrames[this.frameIndex]

        if (frame.disposalType === 2) {
            this.gifCtx.clearRect(0, 0, this.c.width, this.c.height)
        }

        this.draw(frame)
        if (this.material !== null)
            this.material.map.needsUpdate = true;


        // update the frame index
        this.nextFrame()

        const end = performance.now()
        const diff = end - start

        // delay the next gif frame
        requestAnimationFrame(() => {
            this.render()
        })
    }

    load(uri, callback) {
        this._loadGif(uri, callback)
    }

    _loadGif(uri, cb) {
        const oReq = new XMLHttpRequest()
        oReq.open('GET', uri, true)
        oReq.responseType = 'arraybuffer'

        oReq.onload = (oEvent) => {
            const arrayBuffer = oReq.response // Note: not oReq.responseText
            if (arrayBuffer)
                this._onGifLoaded(arrayBuffer, cb)
        }
        oReq.send(null)
    }

    draw(frame) {
        const dims = frame.dims

        if (
            !this.frameImageData ||
            dims.width !== this.frameImageData.width ||
            dims.height !== this.frameImageData.height
        ) {
            this.tempCanvas.width = dims.width
            this.tempCanvas.height = dims.height
            this.frameImageData = this.tempCtx.createImageData(dims.width, dims.height)
        }

        // set the patch data as an override
        this.frameImageData.data.set(frame.patch)

        // draw the patch back over the canvas
        this.tempCtx.putImageData(this.frameImageData, 0, 0)

        this.gifCtx.drawImage(this.tempCanvas, dims.left, dims.top)
    }


    nextFrame() {
        this.frameIndex++
        if (this.frameIndex >= this.loadedFrames.length) {
            if (this.loop)
                this.frameIndex = 0
            else
                this.frameIndex = -1 //Quit
        }
    }


    _renderGIF(frames) {
        this.loadedFrames = frames
        this.frameIndex = 0

        this.gifCanvas.width = this.c.width
        this.gifCanvas.height = this.c.height

        this.render(); //Start rendering
    }

    _onGifLoaded(arrayBuffer, cb) {
        const gif = parseGIF(arrayBuffer)
        const frames = decompressFrames(gif, true)

        this._canvas(gif.lsd.width, gif.lsd.height); //Setup canvas

        // render the gif
        this._renderGIF(frames)


        this.material = new THREE.MeshBasicMaterial({
            side: THREE.DoubleSide,
            map: new THREE.CanvasTexture(this.gifCanvas)
        });
        this.material.needsUpdate = true;

        cb(this.material)
    }

    destroy() {
        this.frameIndex = -1;
        this.c = null
        this.ctx = null
        this.tempCanvas = null
        this.tempCtx = null
        this.gifCanvas = null
        this.gifCtx = null
    }
}

export class GifModelLoader extends ModelLoader {
    constructor() {
        super();
        this.loader = new GifLoader();
    }

    onLoad(material, callback) {
        // console.log("Gif loaded", material)
        const planeGeom = new THREE.PlaneGeometry(1, 1);

        const mesh = new THREE.Mesh(planeGeom, material);

        mesh.scale.set(1.0, material.map.source.data.height / material.map.source.data.width, 1.0);

        super.onLoad(mesh, callback); //Call the callback with our model
    }
}